import styled from "styled-components";

export const StyledInternalGradesChipsContainer = styled.div<{
  $alignFiltersToGrid?: boolean;
}>`
  display: flex;
  gap: 8px;
  overflow-x: auto;
  flex-grow: 1;
  align-items: center;
  padding-left: ${({ $alignFiltersToGrid }) =>
    $alignFiltersToGrid ? "clamp(145px, 8%, 180px)" : "0"};

  & .internal-grades-chip-loading-container {
    padding-left: 8px;
  }
`;
